import { PropTypes } from 'prop-types';

import { Box, Flex } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const OrderSettingsOption = ({ iconName, label, children, onClick, hasWhiteBg }) => (
  <Flex flexDirection="column">
    <P mb="12px" variant="small-semi-bold">
      {label}
    </P>
    <Flex
      flexDirection="column"
      flex={1}
      background={hasWhiteBg ? 'white' : 'transparent'}
      borderRadius="8px"
      p={hasWhiteBg && '16px'}
    >
      <Flex onClick={onClick} as={onClick && 'button'}>
        {iconName && (
          <Box mr="8px">
            <Icon name={iconName} />
          </Box>
        )}
        {children}
      </Flex>
    </Flex>
  </Flex>
);

OrderSettingsOption.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  hasWhiteBg: PropTypes.bool,
};

OrderSettingsOption.defaultProps = {
  iconName: null,
  onClick: undefined,
  hasWhiteBg: true,
};

export { OrderSettingsOption };
